
            const data = {"name":"triangle_right","data":{"width":"6","height":"8","viewBox":"0 0 6 8","data":"<path pid=\"0\" d=\"M0 6.131V1.87a1 1 0 0 1 1.555-.833l3.197 2.132a1 1 0 0 1 0 1.664L1.555 6.964A1 1 0 0 1 0 6.13Z\" _fill=\"#363945\"/>","originalColors":[{"type":"fill","color":"#363945"}],"stopColors":[]}}
        
                    module.exports = data
                    